// extracted by mini-css-extract-plugin
export default {"matrix-table--pad3":"t_b2 ml-3","matrix-table--pad4":"t_b3 ml-5","matrix-table__title":"t_b4","matrix-table__true":"t_b5","matrix-table__false":"t_b6"};